

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.field-with-text {
  display: flex;
  align-items: center;

  gz-text {
    margin-left: 50px;
    padding-bottom: 20px;
  }
}

.field-with-button {
  display: flex;
  align-items: center;

  gz-button {
    margin-left: 15px;
    padding-bottom: 20px;
  }
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width-450 {
    width: 450px;
  }
}
